import axios from 'axios';
import * as types from '@/store/types';

export default {
  async saveAnswers({ commit }, params) {
    try {
      commit(types.SAVE_ANSWERS, params);
      return true;
    } catch (e) {
      commit(types.SAVE_ANSWERS_FAILURE);
      return null;
    }
  },
  async saveAnswersForm({ commit }, params) {
    try {
      commit(types.SAVE_ANSWERS_FORM, params);
      return true;
    } catch (e) {
      commit(types.SAVE_ANSWERS_FORM_FAILURE);
      return null;
    }
  },

  async updateAnswers({}, answers) {
    try {
      await axios.put('/api/web/user/answers', answers);
      return true;
    } catch (e) {
      return null;
    }
  }
};
